import React from 'react';
import { HorizontalFillBar } from 'components/Graphs/FillBars';
import { inPercent } from 'helpers/Utils.js';
import EntityItem from 'components/Global/EntityItem/EntityItem.jsx';
import { ListContainer, ListTitle, ListBarContainer } from 'components/Pages/Reports/styled.js';
import {
  ErrorWrapper,
  ErrorFillBarContainer,
  ErrorTitle,
  ErrorText,
  ErrorDescriptionContainer,
} from './styled.js';

const errorResources = [
  { entity: {}, value: '--', num_contents: 0, pct_num_contents: 1 },
  { entity: {}, value: '--', num_contents: 0, pct_num_contents: 0.9 },
  { entity: {}, value: '--', num_contents: 0, pct_num_contents: 0.8 },
  { entity: {}, value: '--', num_contents: 0, pct_num_contents: 0.7 },
  { entity: {}, value: '--', num_contents: 0, pct_num_contents: 0.6 },
  { entity: {}, value: '--', num_contents: 0, pct_num_contents: 0.5 },
  { entity: {}, value: '--', num_contents: 0, pct_num_contents: 0.4 },
];

export const ErrorEntityListCard = ({ title, unit = 'num_contents' }) => (
  <ErrorWrapper>
    <ErrorFillBarContainer>
      <ListContainer>
        <ListTitle>{title}</ListTitle>
        <ErrorDescriptionContainer width="90%" left>
          <ErrorTitle>No results found.</ErrorTitle>
          <ErrorText>
            We couldn't find any results. Please make sure you've set your competitors or reach out to your Knotch
            associate
          </ErrorText>
        </ErrorDescriptionContainer>
        {errorResources.map((entity, idx) => (
          <ListBarContainer key={`${unit}-error-${idx}`}>
            <EntityItem data={entity} hideName />
            <HorizontalFillBar
              fillPct={inPercent(entity[`pct_${unit}`], 1, true)}
              value={entity.value}
              stacked
              pctWidth="100%"
              labelWidth={'30%'}
            />
          </ListBarContainer>
        ))}
      </ListContainer>
    </ErrorFillBarContainer>
  </ErrorWrapper>
);

export default ErrorEntityListCard;
